// Photos from https://citizenofnowhe.re/lines-of-the-city
import React from "react";
import "./styles.css";
import View1 from '../View/Views/View1'
import View2 from '../View/Views/View2'
import ContactUs from '../View/ContactUs'
import SuportServiceView from "../View/SupportServiceView";
import ViewFAQ from '../View/Views/ViewFAQ'
import ContactUsButton from '../View/ContactUsButton'


function View1Box({ item, index }) {
  return (
    <section key={index}>
      <View1 id={item} item={item} index={index} />
    </section>
  );
}

function View2Box({ item, index }) {
  return (
    <section>
      <View2 id={item} item={item} index={index} />
    </section>
  );
}

function ViewSupport({ item, index, active }) {
  return (
    <section>
      <SuportServiceView id={item} item={item} index={index} active={active} />
    </section>
  );
}

function ViewFAQBox() {
  return (
    <section className="faqSection">
      <ViewFAQ />
    </section>
  );
}

export default function RenderFirst() {
  const list = [
    View1Box,
    View2Box,
    ViewSupport,
    ViewFAQBox,
    ContactUs,
  ];

  return <div className="mainPage">
      {list.map((Item, index) => {
        return (
          <Item id={index} key={index} index={index} active={2}/>
        )
      })}
      <div className='rightView'>
        {ContactUsButton(false, () => {})}
      </div>
    </div>;
}